var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ChevronDownSVG, ChevronUpSVG } from '@snack-uikit/icons';
import { CollapseBlockPrivate } from '../../../helperComponents';
import { CollapseLevelContext, useCollapseContext, useCollapseLevelContext, useSelectionContext, } from '../../Lists/contexts';
import { BaseItem } from '../BaseItem';
import { useGroupItemSelection, useRenderItems } from '../hooks';
export function AccordionItem(_a) {
    var { id, disabled, allChildIds, items } = _a, option = __rest(_a, ["id", "disabled", "allChildIds", "items"]);
    const { level = 0 } = useCollapseLevelContext();
    const { openCollapseItems = [], toggleOpenCollapseItem } = useCollapseContext();
    const { value, isSelectionSingle, isSelectionMultiple } = useSelectionContext();
    const { indeterminate, handleOnSelect, checked: checkedProp, } = useGroupItemSelection({
        items,
        id,
        disabled,
        allChildIds,
    });
    const isOpen = Boolean(openCollapseItems.includes(id !== null && id !== void 0 ? id : ''));
    const checked = Boolean((indeterminate && !isOpen && isSelectionSingle && value && allChildIds.includes(value)) ||
        (isSelectionMultiple && checkedProp));
    const handleKeyDown = useCallback(() => {
        toggleOpenCollapseItem === null || toggleOpenCollapseItem === void 0 ? void 0 : toggleOpenCollapseItem(id !== null && id !== void 0 ? id : '');
    }, [id, toggleOpenCollapseItem]);
    const itemsJSX = useRenderItems(items);
    const handleItemClick = (e) => {
        var _a;
        toggleOpenCollapseItem === null || toggleOpenCollapseItem === void 0 ? void 0 : toggleOpenCollapseItem(id !== null && id !== void 0 ? id : '');
        (_a = option.onClick) === null || _a === void 0 ? void 0 : _a.call(option, e);
    };
    return (_jsx(CollapseBlockPrivate, { header: _jsx(BaseItem, Object.assign({}, option, { id: id, disabled: disabled, expandIcon: isOpen ? _jsx(ChevronUpSVG, {}) : _jsx(ChevronDownSVG, {}), onClick: handleItemClick, isParentNode: true, onOpenNestedList: handleKeyDown, checked: checked, indeterminate: indeterminate, onSelect: !disabled ? handleOnSelect : undefined })), expanded: isOpen, "data-test-id": `list__accordion-item-${id}`, children: _jsx(CollapseLevelContext.Provider, { value: { level: level + 1 }, children: itemsJSX }) }));
}
